export default "__VITE_ASSET__BlDH4lGG__"